export const createFranchiseSlice = (set, get) => ({
  currentFranchise: null,
  setCurrentFranchise: (franchise) => {
    set({ currentFranchise: franchise });

    // Initialize cart with franchise settings when franchise is loaded
    if (franchise) {
      const state = get();
      if (state.initializeCart) {
        state.initializeCart(franchise);
      }
    }
  },
});
